// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export { list, $delete, create, get } from "./operations.js";
export type {
  ServiceListOptionalParams,
  ServiceDeleteOptionalParams,
  ServiceCreateOptionalParams,
  ServiceGetOptionalParams,
} from "./options.js";
